import React, { useState, useEffect, useRef } from 'react';
/* 使用 sessionStorage 缓存共享数据，缓存由 shared/cache.ts 管理 */
import SharingHeader from '../../components/sharing-header';
import SharingIncomeItem from '../../components/sharing-income-item';
import SharingApplyItem from '../../components/sharing-apply-item';
import { CHARGE_CDN, isMyApp, isWX, isWXApp, PILE_SHARING_FORM_KEY } from '../../../../utils/constants';
import {
  getParamsFromHash,
  goBack,
  defineShareInfoInMiniProgram,
  goToPage,
  goToPageV2,
  goToNativePage,
  jumpPage
} from '../../../../utils/common';
import {
  applyUseRefuseReasonEnum,
  getIncomeList,
  getIncomeTotal,
  getPileStatus,
  getSharingStationInfo,
  queryShareApplyInfo,
  querySharePileInfo,
  queryStationDtl,
  queryUseApply,
  queryUseApplyingNo,
  useShareApplyApproval,
  getUserInfo,
  getWaitWithdrawAmount,
  queryFeatureDiagnosis,

} from '../../api';
import { getCurrentUid } from '../../../../api/web-h5-common';
import { queryCurrentUserBasicInfo } from '../../../../api/pile-sharing'
import LoadingPage from '../../../../components/loading-page';
import Empty from '../../components/empty';
import Toast from '@xpeng/rc-toast';
import SharingMessageModal from '../../components/sharing-message-modal';
import SharingRejectModal from '../../components/sharing-reject-modal';
import SharingOpenSuccessModal from '../../components/sharing-open-success-modal';
import SharingCumulativeModal from '../../components/sharing-cumulative-modal';
import SharingPopupMessageModal from '../../components/sharing-popup-message-modal';
import SharePanel from '../../../../components/share-panel';
import { trackGdp } from '../../../../utils/gio-report';
import { UserTypeEnum } from '../../../../api/pile';
import { getRandomItem, generatePoster } from '../../utils';
import { shareGuideTextList } from '../../types';

import './index.less'
import { SafeArea } from 'antd-mobile';
import { List } from '@xp-design/mobile';
import StationCodeModal from '../../components/station-code-modal';
import { getSession, setSession, removeSession, getOrFetchSharePileInfo, getOrFetchStationDtl, getOrFetchCurrentUser } from '../../shared/cache';

const pageSize = 10

const firstThreeTipsList = [
  '乐于分享才能收获更多',
  '鹏友说，快乐因分享而更加快乐',
  '你迈出的一小步，是鹏友的一大步'
]

const App = () => {
  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app

  const [userInfo, setUserInfo] = useState<any>({})
  const [tabIndex, setTabIndex] = useState<number>(0)
  const [applyList, setApplyList] = useState<any[]>([])
  const [incomeList, setIncomeList] = useState<any[]>([])
  const [incomeTotal, setIncomeTotal] = useState<any>({})
  const [isLoading, setIsloading] = useState<boolean>(true)
  const [stationId, setStationId] = useState<string>()
  const [stationData, setStationData] = useState<any>({})
  const [successVisible, setSuccessVisible] = useState<boolean>(false)
  const [firstThreeTips, setFirstThreeTips] = useState<string>('')
  const [firstThreeTipsVisible, setFirstThreeTipsVisible] = useState<boolean>(false)
  const [sharePanelVisible, setSharePanelVisible] = useState<boolean>(false)
  const [rejectVisible, setRejectVisible] = useState<boolean>(false)
  const [cumulativeShareTimes, setCumulativeShareTimes] = useState<number>(0)
  const [cumulativeModalVisible, setCumulativeModalVisible] = useState<boolean>(false)
  const [currentApprovalId, setCurrentApprovalId] = useState<string>('')
  const [rejectReasonList, setRejectReasonList] = useState<any[]>([])
  const [pileInfoData, setPileInfoData] = useState<any>({})
  const [applyNo, setApplyNo] = useState<number>(0)
  const [userApply, setUserApply] = useState<any>({})
  const [featureDiagnosisData, setFeatureDiagnosisData] = useState<any>({})
  const [msgModalData, setMsgModalData] = useState<{
    visible: boolean; text: string; confirmText: string; cancelText: string; withoutCancel?: boolean; title?: string; onConfirm?: () => void; onCancel?: () => void
  }>({
    visible: false,
    text: '',
    cancelText: '',
    confirmText: '',
    withoutCancel: false,
    title: '温馨提示'
  })
  const [incomePageNo, setIncomePageNo] = useState<number>(1)
  const [applyPageNo, setApplyPageNo] = useState<number>(1)
  const [applyListTotal, setApplyListTotal] = useState<number>(0)
  const [incomeListTotal, setIncomeListTotal] = useState<number>(0)
  const [shareGuideText, setShareGuideText] = useState<string>('')
  const [miniShareTitle, setMiniShareTitle] = useState<string>('')
  const [withdrawnAmount, setWithdrawnAmount] = useState<number>(0)
  const [cardBindStatus, setCardBindStatus] = useState<boolean>(false)

  // 新增共享管理二级入口列表状态（共享周报未读，线下码弹窗相关）
  const [reportUnread, setReportUnread] = useState<boolean>(() => {
    const v = localStorage.getItem('sharing_report_unread')
    return v === '1' || v === 'true'
  })
  const [offlineModalVisible, setOfflineModalVisible] = useState<boolean>(false)
  const [offlineQrCode, setOfflineQrCode] = useState<string>('')

  const incomeListRef = useRef(null)
  const applyListRef = useRef(null)
  const incomeListLoading = useRef(false)
  const applyListLoading = useRef(false)
  const pageVisible = useRef(true)

  // 是否关闭了共享
  const isCloseShare = stationData?.operationDto?.stationStatus === '03'
  // 有收益记录 & 未绑卡 & 站未关闭共享时，展示绑卡提示
  const showCardBind = incomeList.length > 0 && !cardBindStatus && !isCloseShare

  const onIncomeScroll = () => {
    const listDom: any = incomeListRef.current;
    if (listDom) {
      const isEnd = listDom.scrollTop + 50 >= listDom.scrollHeight - listDom.clientHeight;
      if (isEnd) {
        // 已经到底了
        if (incomeList.length >= incomeListTotal) {
          return;
        }
        let nextPage = incomePageNo + 1;
        // 如果计算出来的数据量比已有的数据还多，说明上一次还没加载成功，重新来
        if (incomePageNo > 1 && (incomePageNo * pageSize > incomeList.length)) {
          nextPage = incomePageNo;
        }
        setIncomePageNo(nextPage)

        if (stationId && !incomeListLoading.current) {
          getIncomeData(stationId, nextPage)
        }
      }
    }
  };

  const onApplyScroll = () => {
    const listDom: any = applyListRef.current;
    if (listDom) {
      const isEnd = listDom.scrollTop + 50 >= listDom.scrollHeight - listDom.clientHeight;
      if (isEnd) {
        // 已经到底了
        if (applyList.length >= applyListTotal) {
          return;
        }
        let nextPage = applyPageNo + 1;
        // 如果计算出来的数据量比已有的数据还多，说明上一次还没加载成功，重新来
        if (applyPageNo > 1 && (applyPageNo * pageSize > applyList.length)) {
          nextPage = applyPageNo;
        }
        setApplyPageNo(nextPage)

        if (stationId && !applyListLoading.current) {
          getApprovalData(stationId, nextPage)
        }
      }
    }
  };

  const getTabContent = () => {
    switch (tabIndex) {
      case 0:
        return <div className='income-list' onScroll={onIncomeScroll} ref={incomeListRef}>
          {
            showCardBind && (
              <div className='bind-card-tips-wrap' onClick={goToBindCard}>
                <img alt='' src={`${CHARGE_CDN}/sharing/icon_rmb.png`} className='icon-rmb' />
                <div className='text'>录入银行卡信息，收益随时提现</div>
                <img alt='' className='right-icon' src={`${CHARGE_CDN}/sharing/icon_arrow_right_green.png`} />
              </div>
            )
          }
          {
            incomeList.length
              ?
              incomeList.map((item, index) => {
                return <SharingIncomeItem data={item} key={`${index}_item`} userInfo={userInfo} />
              })
              :
              <div className='income-list-empty'>
                <Empty
                  text={shareGuideText}
                  showShareBtn={!isCloseShare}
                  onShare={() => {
                    popSharePanel()
                    trackGdp('P20075', 'B030')
                  }}
                />
              </div>
          }
        </div>
      case 1:
        // 审核列表已迁移到独立页面：/pile-sharing-manage/apply-review
        // 在此保留一个占位入口以触发跳转（如果旧的 tab 逻辑被启用，可以改为导航）
        return <div className='apply-list-placeholder' onClick={goToApplyReview}>
          <div className='user-list' onClick={goToUserList}>
            用户列表
            <img className='more-icon' src={`${CHARGE_CDN}/common/arrow-right-normal.png`} alt='' />
          </div>
          <div className='apply-list-entry' onClick={goToApplyReview}>查看申请审核</div>
        </div>
      default:
        return <div></div>
    }
  }

  const goToBindCard = () => {
    trackGdp('P20075', 'B042')

    const { origin, pathname } = window.location
    goToPageV2({ hash: `/bind-card` })
  }

  // 新增列表项跳转与交互逻辑
  const goToApplyReview = () => {
    // 跳转到独立审核页面（使用 hash 路由约定）
    goToPageV2({ hash: `/apply-review` })
  }

  const goToIncomeRecord = () => {
    goToPageV2({ hash: `/income-record` })
  }
  const goToIncome = () => {
    goToPageV2({ hash: `/income` })
  }

  const goToCashOut = () => {
    goToPageV2({ hash: `/realization` })
  }

  const goToSharingReport = () => {
    // 进入后清除本地 unread 标记
    try {
      localStorage.setItem('sharing_report_unread', '0')
    } catch (e) { /* ignore */ }
    setReportUnread(false)
    // 使用项目内跳转惯例：goToPageV2 + hash
    // 注意：若项目内报告页路径与此不同，请确认正确的 hash 路径
    goToPageV2({ hash: `/sharing-report` })
  }

  const goToSharingClass = () => {
    if(isXPApp) {
      // App 内打开小鹏社区专题页原生版
      jumpPage('xiaopeng://bbs/special?id=931', {})
    } else  {
      // 外链按项目惯例打开
      goToPageV2({ url: 'https://bbs.xiaopeng.com/special/931' }) 
    }
  }

  const openOfflineCodeModal = async () => {
    try {
      const qr = await generatePoster(stationData)
      setOfflineQrCode(qr)
      setOfflineModalVisible(true)
      // 标记已点击保存线下码，清除红点
      try {
        localStorage.setItem(`${userInfo?.uid}_hasClickedSaveOfflineCode`, 'true')
      } catch (e) { /* ignore */ }
    } catch (err) {
      console.error('generatePoster error', err)
    }
  }

  const getQueryFeatureDiagnosis = async (stationId: string) => {
    let QueryFeatureDiagnosisRes = await queryFeatureDiagnosis({ stationId: stationId })
    if (QueryFeatureDiagnosisRes?.code === 200) {
      setFeatureDiagnosisData(QueryFeatureDiagnosisRes.data?.featureDiagnosisDtos || [])
    }
  }

  const goToUserList = () => {
    const { origin, pathname } = window.location
    goToPageV2({ hash: `/user-list?stationId=${stationId}` })
  }

  const getApprovalData = async (stationId: string, pageNo?: number) => {
    try {
      applyListLoading.current = true

      const res = await queryUseApply({
        stationId: stationId,
        pageNo: pageNo || 1,
        pageSize: pageSize,
        dataScope: 2
      })
      // 非初始化不用请求申请中的数据
      const applyingRes = (pageNo && pageNo !== 1) ? { data: { records: [] } } : await queryUseApply({ stationId: stationId, pageNo: 1, pageSize: 100, dataScope: 1 })
      const applyNoRes = await queryUseApplyingNo({ stationId: stationId })

      if (res?.code === 200) {
        setApplyList((pageNo && pageNo !== 1) ? applyList.concat(res?.data?.records) : (applyingRes?.data?.records || []).concat(res?.data?.records))
        setApplyListTotal(res?.data?.total)
      }
      if (applyNoRes?.data && applyNoRes?.code === 200) {
        setApplyNo(applyNoRes?.data?.applyingNo || 0);
      }
    } catch (error) {
      console.log('getApprovalData error', error)
    } finally {
      applyListLoading.current = false
    }
  }

  const getIncomeData = (stationId: string, pageNo = 1) => {
    return new Promise<any>(async (resolve, reject) => {
      incomeListLoading.current = true

      const incomeListRes = await getIncomeList({
        stationId: stationId,
        pageNo,
        pageSize,
      })
      const incomeTotalRes = await getIncomeTotal({
        stationId: stationId,
      })
      if (incomeListRes.code === 200 && incomeListRes?.data) {
        const { unfinishedList = [], finishedList = [] } = incomeListRes.data
        let toSetList: any[] = []
        if (pageNo === 1) {
          toSetList = [...unfinishedList, ...finishedList]
          setIncomeList(toSetList)
          // 已完成订单列表未完结时，需要继续加载，总数+1以便触发下一次上拉加载请求
          setIncomeListTotal(toSetList.length + 1)
        } else {
          toSetList = [...incomeList, ...finishedList]
          setIncomeList(toSetList)
          setIncomeListTotal(finishedList.length >= pageSize ? toSetList.length + 1 : toSetList.length)
        }
      }
      if (incomeTotalRes.code === 200 && incomeTotalRes?.data) {
        setIncomeTotal(incomeTotalRes.data)
      }

      resolve({ incomeTotalData: incomeTotalRes?.data })
    }).catch(err => {

    }).finally(() => {
      incomeListLoading.current = false
    })
  }

  const getUserCardAndWithdrawnAmt = async () => {
    try {
      const userCardRes = await getUserInfo({})
      const withDrawnRes = await getWaitWithdrawAmount({})
      if (userCardRes?.code === 200) {
        // 用户有卡账户信息即已绑卡
        setCardBindStatus(!!userCardRes?.data?.userCardRelaDto?.bankAccount)
      }
      if (withDrawnRes?.code === 200) {
        setWithdrawnAmount(withDrawnRes?.data?.amount || 0)
      }
    } catch (error) {
      console.log('getUserCardAndWithdrawnAmt error', error)
    }
  }

  /**
   * 获取用户登录信息
   */
  const getUser = async () => {
    let newUserInfo = {}
    try {
      const data = await getOrFetchCurrentUser(() => queryCurrentUserBasicInfo());
      newUserInfo = data || {};
      // 切换用户后清除缓存（保留原有 localStorage 清理逻辑）
      if (localStorage.getItem('pileSharingUid') != data?.uid) {
        localStorage.removeItem('pileSharingAgree')
        localStorage.removeItem(PILE_SHARING_FORM_KEY)
        const oldStationId = localStorage.getItem('pileSharingStationId')
        localStorage.removeItem('pileSharingStationId')
        localStorage.removeItem('pileUserInfo')
        localStorage.removeItem('pileSharingFirst')
        // 清理 sessionStorage 中的 ps_* 键
        try {
          removeSession('ps_sharePileInfo')
          removeSession('ps_userInfo')
          if (oldStationId) {
            removeSession(`ps_stationDtl_${oldStationId}`)
          }
        } catch (e) {
          // ignore
        }
      }
    } catch (e) {
      console.log('network error')
    } finally {
      setUserInfo(newUserInfo)
      initPage(newUserInfo)
    }
  }

  const initPage = async (user: any) => {
    try {
      const data = await getOrFetchSharePileInfo(() => querySharePileInfo());

      if (data) {
        setPileInfoData(data)
        await checkPage(data, user)
      }
      const rejectReasonRes = await applyUseRefuseReasonEnum()
      if (rejectReasonRes?.data.length && rejectReasonRes.code === 200) {
        setRejectReasonList(rejectReasonRes.data)
      }
    } catch (e) {
      setIsloading(false)
    }
  }

  const getCurrentUserApply = async (isClose: boolean, pileNo: string) => {
    let userApplyRes = await queryShareApplyInfo({
      pileNo: pileNo,
      applyType: isClose ? 1 : 2
    })
    if (userApplyRes?.code === 200) {
      setUserApply(userApplyRes.data)
    }
  }

  const checkPage = async (data, user) => {
    let tab = getParamsFromHash('tab')

    // 先查询私桩共享总开关是否关闭
    if (!data?.enable) {
      setMsgModalData({
        visible: true,
        confirmText: '好的',
        cancelText: '',
        withoutCancel: true,
        text: '当前功能已结束内测，感谢支持',
        title: '温馨提示',
        onConfirm: goBack
      })
      return
    }
    // 查灰度名单
    if (data?.grayEnable) {
      if (!data?.inGrayList) {
        trackGdp('P20075', 'B018', {
          userId: user?.uid,
          userType: UserTypeEnum[user?.type],
          'user_type': UserTypeEnum[user?.type]
        })
        setMsgModalData({
          visible: true,
          confirmText: '好的',
          cancelText: '',
          withoutCancel: true,
          text: '当前功能暂未完全开放，敬请期待',
          title: '温馨提示',
          onConfirm: goBack
        })
        return
      }
    }

    // 在灰度名单or全量
    // 是否有站
    if (data?.hasStation) {
      // 上报埋点
      trackGdp('P20075', 'B001', {
        userId: user?.uid,
        userType: UserTypeEnum[user?.type],
        'user_type': UserTypeEnum[user?.type]
      })
      setStationId(data?.stationId)

      getQueryFeatureDiagnosis(data.stationId)

      const stationResData = await getOrFetchStationDtl(`${data?.stationId}`, (id) => queryStationDtl({ stationId: id, latitude: 0, longitude: 0 }))

      await getApprovalData(data?.stationId)

      const incomeData = await getIncomeData(data?.stationId)

      if (stationResData) {
        setStationData(stationResData)
        await getCurrentUserApply(stationResData?.operationDto?.stationStatus === '03', data?.pileNo)
        if (stationResData?.operationDto?.stationStatus !== '03') {
          popShareComponent(incomeData?.incomeTotalData?.orderCount, user)
        }
      }

      if (tab === '2') {
        setTabIndex(1)
      }
      setIsloading(false)
    } else {
      if (!data.hasPile) {
        trackGdp('P20075', 'B019', {
          userId: user?.uid,
          userType: UserTypeEnum[user?.type],
          'user_type': UserTypeEnum[user?.type]
        })
        setMsgModalData({
          visible: true,
          confirmText: '去购买',
          cancelText: '好的',
          text: '只有拥有小鹏家充桩的用户可开通共享，你当前没有家充桩',
          title: '',
          onConfirm: () => {
            trackGdp('P20075', 'B020', {
              userId: user?.uid,
              userType: UserTypeEnum[user?.type],
              'user_type': UserTypeEnum[user?.type]
            })
            window.location.href = 'https://mall.xiaopeng.com/product/1530137912979308545?entry=300059'
          },
          onCancel: goBack
        })
        return
      }
      if (data?.type !== 1) {
        trackGdp('P20075', 'B022', {
          userId: user?.uid,
          userType: UserTypeEnum[user?.type],
          'user_type': UserTypeEnum[user?.type]
        })
        setMsgModalData({
          visible: true,
          confirmText: '好的',
          cancelText: '',
          withoutCancel: true,
          text: '你已是他人家充桩的授权用户，只有桩主才能开通共享家充',
          title: '温馨提示',
          onConfirm: goBack
        })
        return
      }
      if (data?.isSatisfyShare !== 1) {
        trackGdp('P20075', 'B021', {
          userId: user?.uid,
          userType: UserTypeEnum[user?.type],
          'user_type': UserTypeEnum[user?.type]
        })
        setMsgModalData({
          visible: true,
          confirmText: '好的',
          cancelText: '去换桩',
          text: '你当前拥有的家充桩暂不支持开通共享家充',
          title: '温馨提示',
          onConfirm: goBack,
          onCancel: () => {
            goToPageV2({ url: 'https://mall.xiaopeng.com/product/1851899228186636290?entry=300059', appId: 'xp_ppstore' })
          }
        })
        return
      }
      if (data?.openApplyStatus === 6) {
        goToApplyStatus(data?.pileNo)
        return
      }
      let shouldGoToManage = [1, 3]
      goToApply(data?.pileNo, data?.hasOpenApply === 1 && shouldGoToManage.includes(data?.openApplyStatus))
    }
  }

  /**
   * 分享弹窗提示
   * 优先级：累计共享X次分享弹窗 > 开通后首次进入 > 第3/8/13次访问的气泡提示
   * --累计共享达到10次/30次/50次/100次，进入后弹窗引导分享
   * @param shareTimes 累计共享次数（共享订单完成数）
   * @param user 用户信息
   */
  const popShareComponent = async (shareTimes, user) => {
    const uid = await getCurrentUid()
    const key = `${uid}_enter_times_after_open`
    // 设置缓存叠加用户进入次数
    let enterTimesAfterOpen: any = localStorage.getItem(key)
    if (enterTimesAfterOpen) {
      localStorage.setItem(key, `${Number(enterTimesAfterOpen) + 1}`)
      enterTimesAfterOpen = Number(enterTimesAfterOpen) + 1
    } else {
      localStorage.setItem(key, '1')
      enterTimesAfterOpen = 1
    }

    if (shareTimes >= 10) {
      let hasPopModal = false
      const handlePopShareTimes = (times: number) => {
        if (!localStorage.getItem(`${uid}_${times}_share_times`)) {
          setMiniShareTitle(`@你，无需购买，我已帮助邻居实现家充共享${times}次，快来试试`)
          setCumulativeShareTimes(times)
          setCumulativeModalVisible(true)
          localStorage.setItem(`${uid}_${times}_share_times`, '1')
          hasPopModal = true

          trackGdp('P20075', 'B033', {
            times
          })
        }
      }

      if (shareTimes >= 10 && shareTimes < 30) {
        handlePopShareTimes(10)
      } else if (shareTimes >= 30 && shareTimes < 50) {
        handlePopShareTimes(30)
      } else if (shareTimes >= 50 && shareTimes < 100) {
        handlePopShareTimes(50)
      } else {
        handlePopShareTimes(100)
      }

      if (hasPopModal) return
    }

    if (enterTimesAfterOpen === 1) {
      setSuccessVisible(true)
      trackGdp('P20075', 'B002', {
        userId: user?.uid,
        userType: UserTypeEnum[user?.type],
        'user_type': UserTypeEnum[user?.type]
      })
      return
    }

    if (enterTimesAfterOpen && [3, 8, 13].includes(Number(enterTimesAfterOpen))) {
      setFirstThreeTipsVisible(true)
      // 5s后用户还没交互关闭，则自动关闭
      setTimeout(() => {
        setFirstThreeTipsVisible(false)
      }, 5000)

      setTimeout(() => {
        trackGdp('P20075', 'B035', {
          content: firstThreeTips
        })
      }, 1000)
    }
  }

  const goToApply = (pileNo: string, openManage: boolean) => {
    const { origin, pathname } = window.location
    window.location.replace(`${origin}${pathname.replace('pile-sharing-manage.html', 'pile-sharing.html')}#/${openManage ? 'manage' : 'apply'}?applyType=1&pileNo=${pileNo}`)
  }

  const goToApplyStatus = (pileNo: string) => {
    const { origin, pathname } = window.location
    window.location.href = `${origin}${pathname.replace('pile-sharing-manage.html', 'pile-sharing.html')}#/manage?applyType=${userApply?.applyType}&pileNo=${pileNo}`
  }

  const popSharePanel = async () => {
    setFirstThreeTipsVisible(false)
    setSharePanelVisible(true)
  }

  const initRandomText = () => {
    setFirstThreeTips(getRandomItem(firstThreeTipsList))
    setShareGuideText(getRandomItem(shareGuideTextList))
    setMiniShareTitle('@你，不限品牌，无需购买也可享受家充，小鹏家充共享功能已开启')
  }

  useEffect(() => {
    document.title = '共享管理'
    getUser()
    getUserCardAndWithdrawnAmt()
    pageVisibleListener()
    initRandomText()
  }, [])

  useEffect(() => {
    defineShareInfoInMiniProgram({
      shareTitle: miniShareTitle,
      shareIcon: `${CHARGE_CDN}/sharing/mini_share_v2.jpg`,
      shareUrl: `pages/home-pile-station-detail/index?stationId=${stationId}`,
    })
  }, [stationData, miniShareTitle])

  useEffect(() => {
    // 绑卡入口曝光埋点
    if (showCardBind) {
      trackGdp('P20075', 'B041')
    }
  }, [withdrawnAmount, cardBindStatus])

  useEffect(() => {
    // 收益记录空状态分享入口曝光
    if (incomeList.length === 0 && !isCloseShare) {
      trackGdp('P20075', 'B029')
    }
  }, [incomeList, stationData?.operationDto?.stationStatus])

  // 每次返回当前TAB需要刷新当前用户数据
  const pageVisibleListener = () => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        pageVisible.current = false
      }
      if (!pageVisible.current && document.visibilityState === 'visible') {
        getUser()
        getUserCardAndWithdrawnAmt()
      }
    })
  }

  const refreshApprovalList = async () => {
    stationId && await getApprovalData(stationId)
  }


  let diagnosisAction = (msg) => {
    const match = msg.match(/【([^】]+)】/);
    return match ? match[1] : '';
  }

  let diagnosisDesc = (msg) => {
    return msg.replace(/【[^】]*】/g, '');
  }

  return (
    <div className='sharing-pile-manage-home'>
      {
        (userApply?.applyStatus === 1)
        &&
        <div className='top-notice-container' onClick={() => goToApplyStatus(pileInfoData?.pileNo)}>
          <img src={`${CHARGE_CDN}/sharing/icon_info_warning.png`} className='icon-info-warning' alt="" />
          <div className='notice-text'>{isCloseShare ? '申请审核中，共享生活即将开启，审核期间请保持【桩通电状态】，审核将在7个工作日内完成' : '资料修改审核中，将在7个工作日内完成。'}</div>
          <img src={`${CHARGE_CDN}/sharing/alert_arrow_right.png`} className='alert-arrow-right' alt="" />
        </div>
      }
      {
        (userApply?.applyStatus === 6) &&
        <div className='top-notice-container top-notice-container1' onClick={() => goToApplyStatus(pileInfoData?.pileNo)}>
          <img src={`${CHARGE_CDN}/sharing/icon_info_green.png`} className='icon-info-warning' alt="" />
          <div className='notice-text'>信息审核已通过，还差最后一步！请将【充电桩保持通电状态】，系统将自动升级，升级完成后即可使用共享家充服务</div>
          <img src={`${CHARGE_CDN}/sharing/icon_arrow_right_green.png`} className='alert-arrow-right' alt="" />
        </div>
      }

      {
        isLoading
          ?
          <LoadingPage />
          :
          <>
            <SharingHeader
              stationId={stationId}
              data={stationData}
              pileInfoData={pileInfoData}
              incomeTotal={incomeTotal}
              userInfo={userInfo}
              firstThreeTipsInfo={{
                visible: firstThreeTipsVisible,
                text: firstThreeTips
              }}
              onShare={popSharePanel}
            />
            {
              featureDiagnosisData.length > 0 && featureDiagnosisData?.[0].type === 1 && (
                <div className='diagnosis-wrap' onClick={() => { }}>
                  <div className='diagnosis-row'>
                    <img alt='' src={`${CHARGE_CDN}/sharing/icon_rmb.png`} className='icon-rmb' />
                    <div className='text'>共享收益丢失风险</div>
                  </div>
                  <div className='diagnosis-desc'>
                    {diagnosisDesc(featureDiagnosisData?.[0]?.diagnosisMsg || '')}
                  </div>
                  <div className='diagnosis-action' onClick={(e) => {
                    e.stopPropagation();
                    if (isXPApp || isWXApp || isMyApp) {
                      goToNativePage({
                        mini: '/home-pile/pages/setting/index',
                        app: 'xiaopeng://account/charging/my',
                      })
                    } else {
                      Toast.show('请在小鹏APP内进行操作', {
                        containerStyle: {
                          zIndex: 9999
                        }
                      })
                    }
                  }}>
                    {diagnosisAction(featureDiagnosisData?.[0]?.diagnosisMsg || '')}
                    <img alt='' className='right-icon' src={`${CHARGE_CDN}/sharing/icon_arrow_right_green.png`} />
                  </div>
                </div>
              )
            }
            {/* 新增共享管理二级入口列表：申请审核、收益记录、收益提现、共享周报、共享小课堂、保存线下码 */}
            <List className='sharing-secondary-list'>
              <List.Item onClick={goToApplyReview} extra={applyNo > 0 ? <div className={`applyno ${applyNo > 10 ? 'too-many-apply' : ''}`}>{applyNo >= 99 ? '99+' : applyNo}</div> : null}>
                申请审核
              </List.Item>
              <List.Item onClick={goToIncomeRecord}>
                收益记录
              </List.Item>
              <List.Item onClick={goToIncome} extra={withdrawnAmount !== 0 ? `${withdrawnAmount}元待提现` : null}>
                收益提现
              </List.Item>
              {/* <List.Item onClick={goToSharingReport}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                  <span>共享周报</span>
                  {reportUnread && <span className='sharing-report-red-dot' />}
                </div>
              </List.Item> */}
              <List.Item onClick={goToSharingClass}>
                共享小课堂
              </List.Item>
              <List.Item onClick={openOfflineCodeModal}>
                保存线下码
              </List.Item>
            </List>

            {/* <div className='tab-group'>
              <div className={`tab ${tabIndex === 0 ? 'tab-active' : ''}`} onClick={() => setTabIndex(0)}>共享收益</div>
              <div className={`tab ${tabIndex === 1 ? 'tab-active' : ''}`} onClick={() => setTabIndex(1)}>申请审核
                {
                  applyNo > 0
                  &&
                  <div className={`applyno ${applyNo > 99 ? 'too-many-apply' : ''}`}>
                    {applyNo > 99 ? '99+' : applyNo}
                  </div>
                }
              </div>
            </div> */}
            {/* {getTabContent()} */}
          </>
      }

      <SharingOpenSuccessModal
        visible={successVisible}
        setVisible={(status) => {
          setSuccessVisible(status)
        }}
        userInfo={userInfo}
        onShare={popSharePanel}
      />
      <SharingCumulativeModal
        visible={cumulativeModalVisible}
        onClose={() => setCumulativeModalVisible(false)}
        shareTimes={cumulativeShareTimes}
        imgUrl={`${CHARGE_CDN}/sharing/cumulative_share_bg.png`}
        onShare={() => {
          popSharePanel()
          trackGdp('P20075', 'B034', {
            times: cumulativeShareTimes
          })
        }}
      />
      <SharingRejectModal
        visible={rejectVisible}
        setVisible={(status) => setRejectVisible(status)}
        refreshList={refreshApprovalList}
        approvalId={currentApprovalId}
        userInfo={userInfo}
      />
      <SharingMessageModal
        visible={msgModalData.visible}
        confirmText={msgModalData.confirmText}
        cancelText={msgModalData.cancelText}
        onCancel={msgModalData?.onCancel ? msgModalData?.onCancel : () => setMsgModalData({ ...msgModalData, visible: false })}
        onConfirm={msgModalData?.onConfirm ? msgModalData?.onConfirm : () => setMsgModalData({ ...msgModalData, visible: false })}
        text={msgModalData.text}
        withoutCancel={msgModalData.withoutCancel}
        title={msgModalData.title}
      />
      <SharePanel
        visible={sharePanelVisible}
        onClose={() => setSharePanelVisible(false)}
        contentClassName='pile-share-panel'
        shareInfo={{
          shareMainTitle: miniShareTitle,
          shareSubTitle: '',
          shareImgUrl: `${CHARGE_CDN}/sharing/mini_share_v2.jpg`,
          sharePageUrl: `pages/home-pile-station-detail/index?stationId=${stationId}`
        }}
        getPosterBase64Data={() => generatePoster(stationData)}
        btns={['wx', 'poster']}
        onClickWx={() => {
          trackGdp('P20075', 'B023')
        }}
        onClickPoster={() => {
          trackGdp('P20075', 'B024')
        }}
      />
      {/* 新增：用于列表中“保存线下码”的弹窗复用 */}
      <StationCodeModal
        visible={offlineModalVisible}
        onClose={() => setOfflineModalVisible(false)}
        qrCode={offlineQrCode}
      />
    </div>
  )
}

export default App;